import React from "react";
import {
    RydBookmark,
    RydBookmarkSelection
} from "../../../model/bookmark";
import {
    useLoopPlaybackSetup,
    useSetLoopPlaybackSetup
} from "../../../stores/PlaybackConfStore";
import './RydBookmarksContainer.css';
import {
    useSetWorkspaceBookmarks,
    useSetWorkspaceComputedContextFrame,
    useSetWorkspaceContextPlane,
    useSetWorkspaceLines
} from "../../../stores/WorkspaceStore";
import { RydProject } from "../../../model/project";
import { RydBookmarkGlyph } from "./RydBookmarkGlyph";
import { NOTE_WIDTH, tickToPosition } from "../../../render/renderUtils";
import { sanitizeProjectLengthIfNeeded } from "../../../services/ProjectConsistencyService";


export function RydBookmarksContainer({
    project,
    canvasWidth,
    zoomFactor,
    bookmarks,
    showLoops
}: {
    project: RydProject,
    canvasWidth: number,
    zoomFactor: number,
    bookmarks: (RydBookmark & RydBookmarkSelection)[],
    showLoops: boolean,
}) {
    const loopPlaybackSetup = useLoopPlaybackSetup();
    const setLoopPlaybackSetup = useSetLoopPlaybackSetup();
    const setWorkspaceBookmarks = useSetWorkspaceBookmarks();
    const setWorkspaceContextPlane = useSetWorkspaceContextPlane();
    const setWorkspaceLines = useSetWorkspaceLines();
    // const setWorkspaceComputedContextFrame = useSetWorkspaceComputedContextFrame();

    return (<div className={"ryd-bookmarks--timeline-container"} style={{
        width: `${canvasWidth}px`,
    }}>
        {bookmarks.map((b, i) =>
            <RydBookmarkGlyph
                key={i}
                project={project}
                bookmark={b}
                zoomFactor={zoomFactor}
                onUpdate={(b: RydBookmark) => {
                    project.bookmarks[i] = b;
                    sanitizeProjectLengthIfNeeded(project, b, { setWorkspaceContextPlane, setWorkspaceLines });
                    setWorkspaceBookmarks([...project.bookmarks]);
                }}
            />
        )}
        {showLoops && (loopPlaybackSetup.start && loopPlaybackSetup.end) &&
            <>
                <div className={"timeline--loop-region"}
                    style={{
                        left: `calc(${tickToPosition(NOTE_WIDTH, zoomFactor, loopPlaybackSetup.start.position)}px + var(--piano-roll-header-width))`,
                        width: tickToPosition(NOTE_WIDTH, zoomFactor, loopPlaybackSetup.end.position - loopPlaybackSetup.start.position),
                    }}>&nbsp;</div>
                <RydBookmarkGlyph
                    key="loop-start"
                    project={project}
                    bookmark={{ ...loopPlaybackSetup.start, selected: false }}
                    zoomFactor={zoomFactor}
                    onUpdate={(b: RydBookmark) => {
                        loopPlaybackSetup.start = b;
                        setLoopPlaybackSetup({ ...loopPlaybackSetup });
                    }}
                />
                <RydBookmarkGlyph
                    key="loop-end"
                    project={project}
                    bookmark={{ ...loopPlaybackSetup.end, selected: false }}
                    zoomFactor={zoomFactor}
                    onUpdate={(b: RydBookmark) => {
                        loopPlaybackSetup.end = b;
                        sanitizeProjectLengthIfNeeded(project, b, { setWorkspaceContextPlane, setWorkspaceLines });
                        setLoopPlaybackSetup({ ...loopPlaybackSetup });
                    }}
                />
            </>
        }
    </div>);
}
